"use strict";
import mediumStyles from "./src/scale-medium.css.js";
import { Theme } from "./src/Theme.dev.js";
import "./core.dev.js";
Theme.registerThemeFragment("medium", "scale", mediumStyles);
//# sourceMappingURL=scale-medium.dev.js.map
